// import Swiper from 'swiper/js/swiper.min';
export default {
  init: function init() {
    var exhibImgCap = $('#exhibition-section .image-container .caption');
    var exhibImgCapPar = $('#exhibition-section .image-container .caption p');
    var exhibImgCapHeight = $('#exhibition-section .image-container .caption').height();
    $('<div class="left"></div>').css('height', exhibImgCapHeight * 1.5).insertBefore(exhibImgCapPar);
    $('<div class="right"></div>').css('height', exhibImgCapHeight * 1.5).insertBefore(exhibImgCapPar);
    var aboutImgCap = $('#about-section .image-container .caption');
    var aboutImgCapPar = $('#about-section .image-container .caption p');
    var aboutImgCapHeight = $('#about-section .image-container .caption').height();
    $('<div class="left"></div>').css('height', aboutImgCapHeight * 1.5).insertBefore(aboutImgCapPar);
    $('<div class="right"></div>').css('height', aboutImgCapHeight * 1.5).insertBefore(aboutImgCapPar);
  },
  finalize: function finalize() {
    // JavaScript to be fired on the home page, after the init JS
    window.onload = function () {
      var banner_spans = document.getElementById('banner').querySelectorAll('span');

      if (banner_spans !== undefined) {
        var _loop = function _loop(i) {
          setTimeout(function () {
            banner_spans[i].classList.add('loaded');
          }, 250 * i + 1500);
        };

        for (var i = 0; i < banner_spans.length; i++) {
          _loop(i);
        }
      }
    };
  }
};


// WEBPACK FOOTER //
// ./scripts/routes/home.js